import { GetItemsProps, useApiService } from "medere-ui-framework";
import { ComboDataDTO } from "../../dto/ComboDataDTO";

export function useEntityService() {
  const { getMethod } = useApiService();

  function getProfessionals({ filterValue, offSet, pageSize }: GetItemsProps): Promise<any[]> {
    return getMethod<any[]>({
      basePath: "/api/secured/surgery",
      endpoint: "/getProfessionals",
      params: {
        offSet,
        pageSize,
        inputText: filterValue ?? "",
      }
    }).catch((error) => {
      console.error(error);
      throw error;
    });
  }

  function getPatients(inputText: string, offSet: number, pageSize: number): Promise<any[]> {
    return getMethod<any[]>({
      basePath: "/api/secured/surgery",
      endpoint: "/getPatients",
      params: { offSet, pageSize, inputText }
    }).catch((error) => {
      console.error(error);
      throw error;
    });
  }

  function getNomenclatorTypes({ filterValue, offSet, pageSize }: GetItemsProps): Promise<any[]> {
    return getMethod<any[]>({
      basePath: "/api/secured/honorarium",
      endpoint: "/getNomenclatorTypes",
      params: {
        offSet,
        pageSize,
        inputText: filterValue ?? "",
      }
    }).catch((error) => {
      console.error(error);
      throw error;
    });
  }

  function getNomenclators({ filterValue, offSet, pageSize, params }: GetItemsProps): Promise<any[]> {
    return getMethod<any[]>({
      basePath: "/api/secured/honorarium",
      endpoint: "/getNomenclators",
      params: {
        offSet,
        pageSize,
        inputText: filterValue ?? "",
        nomenclatorTypes: params.nomenclatorTypes.join(","),
        orderByNomenclatorType: params.orderByNomenclatorType,
        healthEntity: params.healthEntity ?? -1
      }
    }).catch((error) => {
      console.error(error);
      throw error;
    });
  }

  function getDefaultCity(): Promise<ComboDataDTO> {
    return getMethod<any>({
      basePath: "/api/secured/profile/profiledataform",
      endpoint: "/getDefaultCity"
    }).then(response => ({
      id: response?.city ?? -1,
      name: response?.description ?? "",
      isExternalId: false,
    }));
  }

  function getHealthEntityComboDataDTO({ filterValue, offSet, pageSize }: GetItemsProps): Promise<any[]> {
    return getMethod<any[]>({
      basePath: "/api/secured/entities",
      endpoint: "/getHealthEntityComboDataDTO",
      params: {
        offSet,
        pageSize,
        inputText: filterValue ?? "",
      }
    }).catch((error) => {
      console.error(error);
      throw error;
    });
  }

  function getHealthEntityPlanDTO({ filterValue, offSet, pageSize, params }: GetItemsProps): Promise<any[]> {
    return getMethod<any[]>({
      basePath: "/api/secured/entities",
      endpoint: "/getHealthEntityPlanDTO",
      params: {
        offSet,
        pageSize,
        inputText: filterValue ?? "",
        healthentity: params.healthentity ?? -1
      }
    }).catch((error) => {
      console.error(error);
      throw error;
    });
  }

  function getHealthEntityDataDTO({ filterValue, offSet, pageSize }: GetItemsProps, healthentityid: number): Promise<any[]> {
    return getMethod<any[]>({
      basePath: "/api/secured/entities",
      endpoint: "/getHealthEntityDataDTO",
      params: {
        offSet,
        pageSize,
        inputText: filterValue ?? "",
        healthentityid: healthentityid
      }
    }).catch((error) => {
      console.error(error);
      throw error;
    });
  }

  return {
    getProfessionals,
    getPatients,
    getNomenclatorTypes,
    getNomenclators,
    getDefaultCity,
    getHealthEntityComboDataDTO,
    getHealthEntityPlanDTO,
    getHealthEntityDataDTO,
  };
}
